import * as React from "react";
import type { SVGProps } from "react";
const SvgPantryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M3.92 1.68a.56.56 0 0 0-.56.56v24.08c0 .31.25.56.56.56h2.24c.31 0 .56-.25.56-.56v-4.478l14.56.05v4.428c0 .31.25.56.56.56h2.24c.31 0 .56-.25.56-.56V2.24a.56.56 0 0 0-.56-.56h-2.24a.56.56 0 0 0-.56.56v7.891l-1.68-.005V6.72a.6.6 0 0 0-.06-.25l-.5-1.002V4.48a.56.56 0 0 0-.56-.56h-2.8a.56.56 0 0 0-.56.56v.988l-.501 1.001a.6.6 0 0 0-.059.25v3.39l-1.68-.006V6.16a.56.56 0 0 0-.56-.56H8.96a.56.56 0 0 0-.56.56v3.928l-1.68-.006V2.24a.56.56 0 0 0-.56-.56zm.56 1.12H5.6v22.96H4.48zm17.92 0h1.12v22.96H22.4V2.8m-6.16 2.24h1.68v.56c0 .087.02.173.059.25l.501 1.002v3.228h-2.8V6.852l.5-1.002a.6.6 0 0 0 .06-.25zM9.52 6.72h2.24v3.36H9.52zm-2.8 4.482 14.56.05v9.52l-1.162-.004-.52-6.254A.56.56 0 0 0 19.04 14h-1.68a.56.56 0 0 0-.558.514l-.52 6.24-1.722-.006V18.48c.31 0 .56-.25.56-.56v-2.24a.56.56 0 0 0-.56-.56H8.4a.56.56 0 0 0-.56.56v2.24c0 .31.25.56.56.56v2.248l-1.68-.006zm11.155 3.918h.65l.466 5.6h-1.582zM8.96 16.24H14v1.12H8.96zm.56 2.24h3.92v2.24H9.52z"
    />
  </svg>
);
export default SvgPantryIcon;
